import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from 'react-router-dom';

import { Devtools } from ':fat/components/Devtools/Devtools';
import { EnsureMessagingAndWorkersAreSetup } from ':fat/components/EnsureMessagingAndWorkersAreSetup';
import { PageLayout } from ':fat/components/PageLayout';
import { SecurityFrameSidecar } from ':fat/components/SecurityFrameSidecar';
import { SecurityFrameSignerProvider } from ':fat/components/SecurityFrameSignerContext';
import { SecurityFrameWrapper } from ':fat/components/SecurityFrameWrapper';
import { BroadcastingPage } from ':fat/pages/Broadcasting/BroadcastingPage';
import { EnterWalletAddressesPage } from ':fat/pages/EnterWalletAddresses/EnterWalletAddressesPage';
import { ErrorFallbackPage } from ':fat/pages/ErrorFallback';
import { GetStartedPage } from ':fat/pages/GetStartedPage/GetStartedPage';
import { LoadingPage } from ':fat/pages/Loading';
import { ReviewPage } from ':fat/pages/Review/ReviewPage';
import { ScanningPage } from ':fat/pages/Scanning';
import { SecurityFrameLoaderPage } from ':fat/pages/SecurityFrameLoader';
import { ServiceUnavailablePage } from ':fat/pages/ServiceUnavailable';
import { StatusPage } from ':fat/pages/Status/StatusPage';

import { AppRoutes } from './routes';

// TODO: code-split the top-level routes for the main page and security frame
const routes = createRoutesFromElements(
  <>
    <Route
      path={AppRoutes.SECURITY_FRAME.BASE}
      element={
        <SecurityFrameSignerProvider>
          <PageLayout inSecurityFrame />
          <SecurityFrameSidecar />
        </SecurityFrameSignerProvider>
      }
    >
      <Route path={AppRoutes.SECURITY_FRAME.BASE} element={<ServiceUnavailablePage />} />
      <Route path={AppRoutes.SECURITY_FRAME.THINKING} element={null} />
    </Route>
    <Route
      path={AppRoutes.BASE}
      element={
        <EnsureMessagingAndWorkersAreSetup>
          <PageLayout />
          <SecurityFrameWrapper />
          {process.env.RELEASE_STAGE !== 'production' && <Devtools />}
        </EnsureMessagingAndWorkersAreSetup>
      }
      errorElement={<ErrorFallbackPage />}
    >
      <Route path={AppRoutes.BASE} element={<GetStartedPage />} />
      <Route path={AppRoutes.SECURITY_FRAME_LOADER} element={<SecurityFrameLoaderPage />} />
      <Route path={AppRoutes.SCANNING} element={<ScanningPage />} />
      <Route path={AppRoutes.ENTER_WALLET_ADDRESSES} element={<EnterWalletAddressesPage />} />
      <Route path={AppRoutes.REVIEW} element={<ReviewPage />} />
      <Route path={AppRoutes.BROADCASTING} element={<BroadcastingPage />} />
      <Route path={AppRoutes.STATUS} element={<StatusPage />} />
      <Route path="*" element={<Navigate to={AppRoutes.BASE} replace />} />,
    </Route>
  </>,
);

const router = createBrowserRouter(routes);

export function RouterProviderWithContext() {
  return <RouterProvider router={router} fallbackElement={<LoadingPage />} />;
}
